var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 40,
    viewBox: "0 0 44 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 39,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 39,
    rx: 3.5,
    stroke: "#E5E5E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0667 28.2833L25.6751 23.6667C25.9834 23.3583 26.1584 22.9333 26.1584 22.4917V14.1667C26.1584 13.25 25.4084 12.5 24.4917 12.5H17.0001C16.3334 12.5 15.7334 12.9 15.4751 13.5083L12.7584 19.85C12.0501 21.5 13.2584 23.3333 15.0501 23.3333H19.7584L18.9667 27.15C18.8834 27.5667 19.0084 27.9917 19.3084 28.2917C19.8001 28.775 20.5834 28.775 21.0667 28.2833ZM29.5001 12.5C28.5834 12.5 27.8334 13.25 27.8334 14.1667V20.8333C27.8334 21.75 28.5834 22.5 29.5001 22.5C30.4167 22.5 31.1667 21.75 31.1667 20.8333V14.1667C31.1667 13.25 30.4167 12.5 29.5001 12.5Z",
    fill: "#959BA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlike);
export default __webpack_public_path__ + "static/media/unlike.8d77fea4643b84bc6b2741d86bc5e347.svg";
export { ForwardRef as ReactComponent };